import React from 'react';

const AccessDenied = () => <h2>Access Denied</h2>;

export default AccessDenied;
